import { Model } from '@vuex-orm/core'

export default class Account extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'accounts'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      name: this.attr(null),
      billing_enable: this.attr(null),
      is_prolong: this.attr(null),
      prolong_is_after: this.attr(null),
      prolong_date: this.attr(null),
      prolong_reason: this.attr(null),
      is_overdue_invoice: this.attr(null),
      slug: this.attr(null),
      accepted_terms: this.attr(null),
      active: this.attr(null),
      logo_media_id: this.attr(null),
      logo_media_url: this.attr(null),
      domains: this.attr(null),
      social: this.attr(null),
      applyfields: this.attr(null),
      settings: this.attr(null),
      conversational_agent: this.attr(null),
      careersite: this.attr(undefined)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Account.js